import React from 'react'

import LoaderComponent from '../LoaderComponent'

class LoadingFullScreen extends React.Component {
  state = {
    className: 'area_full_loading',
    style: {}
  }

  componentDidUpdate (prevProps) {
    if (prevProps.show && !this.props.show) {
      setTimeout(() => { this.setState({ className: 'area_full_loading loading_out' }) }, 100)
      setTimeout(() => { this.setState({ style: { display: 'none' } }) }, 100)
    } else if (!prevProps.show && this.props.show) {
      this.setState({ className: 'area_full_loading', style: {} })
    }
  }

  render () {
    return (
      <div className={this.state.className} style={this.state.style} >
        {this.props.cssLoaded && <LoaderComponent/>}
      </div>
    )
  }
}

export default LoadingFullScreen
